/* import __COLOCATED_TEMPLATE__ from './editable-user-name.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
/* eslint-disable promise/prefer-await-to-then */
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { findBy } from '@intercom/pulse/lib/computed-properties';
import EditableAttribute from 'embercom/components/people/attributes/editable-attribute';

export default EditableAttribute.extend({
  userUpdaterService: service(),
  attributeService: service(),
  classNameBindings: ['isNotEditing:inbox__user-profile__name-editor'],
  attribute: findBy('attributeService.attributes', 'identifier', 'name'),
  attributeBindings: ['data-test-section-editable-name'],
  'data-test-section-editable-name': true,

  _updateDisplayName() {
    let mainParticipant = this.get('displayedConversation.main_participant');
    if (mainParticipant && mainParticipant.get('user_id') === this.get('person.id')) {
      this.userUpdaterService.updateData(mainParticipant, {
        display_as: this.currentAttributeValue,
      });
    }
    this.person.updateLeadName(this.currentAttributeValue);
  },

  completeEditing: action(function (value) {
    if (value !== this.currentAttributeValue) {
      this.updateAttributeValue.perform(value).then(() => this._updateDisplayName());
    }
    this.set('isEditing', false);
  }),
});
